<script lang="ts">
	import __ from '$lib/stores/TranslationStore';
	import Facebook from '$lib/assets/images/icons/facebook.svg?component';
	import WhatsApp from '$lib/assets/images/icons/whatsapp.svg?component';
	import Linkedin from '$lib/assets/images/icons/linkedin.svg?component';
	import type { ComponentType, SvelteComponentTyped } from 'svelte';
	import type { SVGAttributes } from 'svelte/elements';
	import { page } from '$app/stores';
	import type { HTMLAnchorAttributes } from 'svelte/elements';
	import { dev } from '$app/environment';
	import { PUBLIC_SOCIAL_ACCESS_KEY } from '$env/static/public';
	import { twMerge } from 'tailwind-merge';

	type HyperlinkOptions = HTMLAnchorAttributes & Record<string, string>;

	type SocialInfo = {
		label: string;
		svg: ComponentType<SvelteComponentTyped<SVGAttributes<SVGSVGElement>>>;
		shareUrl: string;
		mobileUrl?: string;
		hyperlinkOptions?: HyperlinkOptions;
		popup: boolean;
	};

	const sharingUrl: string = `${
		dev ? `https://www.poupancanominuto.com${$page.url.pathname}` : $page.url.href
	}`;

	function getSharingUrl(socialMedia: string) {
		const url =
			sharingUrl +
			'?' +
			new URLSearchParams({
				utm_source: 'poupancanominuto',
				utm_medium: 'redes-sociais-artigo',
				utm_campaign: socialMedia
			});

		return url;
	}

	export let socials: SocialInfo[] = [
		{
			label: 'Facebook',
			svg: Facebook,
			shareUrl: `https://www.facebook.com/sharer/sharer.php?u=${getSharingUrl(
				'facebook'
			)}&kid_directed_site=0&sdk=joey&display=popup`,
			popup: true
		},
		{
			label: 'WhatsApp',
			svg: WhatsApp,
			shareUrl: `https://web.whatsapp.com/send?text=${getSharingUrl('whatsapp')}`,
			mobileUrl: `https://api.whatsapp.com/send?text=${getSharingUrl('whatsapp')}`,
			hyperlinkOptions: {
				'data-action': 'share/whatsapp/share'
			},
			popup: false
		},
		{
			label: 'Linkedin',
			svg: Linkedin,
			shareUrl: `https://www.linkedin.com/shareArticle?mini=true&url=${
				encodeURIComponent(getSharingUrl('linkedin')) || ''
			}`,
			popup: true
		}
	];

	let className: string = '';
	export { className as class };

	function handlePopup(e: MouseEvent, social: SocialInfo): void {
		if (social.popup) {
			e.preventDefault();
			popupShare(social.shareUrl, social.label);
		}
	}

	function popupShare(url: string, socialLabel: string): void {
		const width = 550;
		const height = 700;
		const left = (window.innerWidth - width) / 2;
		const top = (window.innerHeight - width) / 2;
		const options = `scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=${width},height=${height},left=${left},top=${top}`;

		window.open(url, `Share on ${socialLabel}`, options);
	}
</script>

<div
	class={twMerge(
		'flex flex-col items-stretch gap-y-4 border-b-2 px-8 py-5 md:px-32 lg:border-b-0 lg:px-0',
		className
	)}
>
	<slot name="header">
		<p class="self-center text-sm text-neutral-400 lg:self-auto">
			{$__('Gostou do que leu? Partilhe!')}
		</p>
	</slot>
	<section class="flex items-center justify-around gap-x-2 md:gap-x-8 lg:justify-start lg:gap-x-10">
		{#each socials as social}
			<a
				on:click={(e) => handlePopup(e, social)}
				class="text-primary underline"
				class:lg:hidden={social.mobileUrl}
				aria-label={`${$__('Partilhar no')} ${social.label}`}
				href={social.mobileUrl || social.shareUrl}
				{...social.hyperlinkOptions}
				target="_blank"
			>
				<svelte:component
					this={social.svg}
					class="h-8 fill-primary transition-colors hover:fill-primary-light lg:h-7"
				/>
			</a>
			{#if social.mobileUrl}
				<a
					on:click={(e) => handlePopup(e, social)}
					class="hidden text-primary underline lg:block"
					href={social.shareUrl}
					{...social.hyperlinkOptions}
					target="_blank"
				>
					<svelte:component
						this={social.svg}
						class="h-8 fill-primary transition-colors hover:fill-primary-light lg:h-7"
					/>
				</a>
			{/if}
		{/each}
	</section>
</div>
